module.exports = function (name, content) {
  return '<' + name + '>' + content + '</' + name + '>'
}
